"use strict";
exports.__esModule = true;
require('./topology-view.css');
exports.default = {
  "topologyContainer": "pf-topology-container",
  "topologyContent": "pf-topology-content"
};